import React, { useRef, useEffect } from 'react';
import { css, cx } from 'linaria';
import { usePrevious } from 'common/utilities/hooks/has-changed';
const itemWrapper = "iqzeq5h";
export const TypeAheadItem = ({
  item,
  index,
  action,
  isActive
}) => {
  const ref = useRef();
  const prevActive = usePrevious(isActive);
  useEffect(() => {
    if (prevActive) return;
    if (isActive) ref.current.scrollIntoView({
      block: 'center'
    });
  }, [isActive, prevActive]);

  const clickAction = () => action(index);

  return <div className={cx(itemWrapper, isActive && 'isActive')} onClick={clickAction}>
      <span ref={ref}>{item}</span>
    </div>;
};

require("./type-ahead.item.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./type-ahead.item.js");